import { DefaultComponent } from './default.component';
import { HelpMenuComponent } from './help-menu/help-menu.component';
import { ProfileMenuComponent } from './profile-menu/profile-menu.component';
import { SettingsMenuComponent } from './settings-menu/settings-menu.component';
import { SystemInfoComponent } from './system-info/system-info.component';
import { ToolbarComponent } from './toolbar/toolbar.component';
import { ViewMenuComponent } from './view-menu/view-menu.component';

export const appComponents: any[] = [
  ProfileMenuComponent,
  SettingsMenuComponent,
  HelpMenuComponent,
  ViewMenuComponent,
  SystemInfoComponent,
  ToolbarComponent,
  DefaultComponent,
];

export { DefaultComponent };
export { HelpMenuComponent };
export { ProfileMenuComponent };
export { SettingsMenuComponent };
export { SystemInfoComponent };
export { ToolbarComponent };
export { ViewMenuComponent };
